/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkClaimPropertyRequest
 */
export interface LinkClaimPropertyRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkClaimPropertyRequest
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkClaimPropertyRequest
     */
    addressType?: LinkClaimPropertyRequestAddressTypeEnum;
}


/**
 * @export
 */
export const LinkClaimPropertyRequestAddressTypeEnum = {
    Loss: 'loss',
    Billing: 'billing',
    Other: 'other'
} as const;
export type LinkClaimPropertyRequestAddressTypeEnum = typeof LinkClaimPropertyRequestAddressTypeEnum[keyof typeof LinkClaimPropertyRequestAddressTypeEnum];


/**
 * Check if a given object implements the LinkClaimPropertyRequest interface.
 */
export function instanceOfLinkClaimPropertyRequest(value: object): value is LinkClaimPropertyRequest {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    return true;
}

export function LinkClaimPropertyRequestFromJSON(json: any): LinkClaimPropertyRequest {
    return LinkClaimPropertyRequestFromJSONTyped(json, false);
}

export function LinkClaimPropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkClaimPropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'addressType': json['addressType'] == null ? undefined : json['addressType'],
    };
}

export function LinkClaimPropertyRequestToJSON(json: any): LinkClaimPropertyRequest {
    return LinkClaimPropertyRequestToJSONTyped(json, false);
}

export function LinkClaimPropertyRequestToJSONTyped(value?: LinkClaimPropertyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'addressType': value['addressType'],
    };
}

